// extracted by mini-css-extract-plugin
export default {"legacyContainer":"StickyPortal_legacyContainer__076OZ","container":"StickyPortal_container__npyAA"};